const SubmitButton = ({ label, handleClick, className = "px-5 py-5" }) => {
    return(
        <div className={className}>
            <button
                onClick={handleClick}
                type="submit"
                className="w-full inline-flex justify-center rounded-md border border-transparent bg-green-600 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-secundarioMira hover:border-green-600 hover:border-2 focus:outline-none"
            >
                <div className="flex">
                    {/*<MagnifyingGlassIcon className="h-5 w-5 text-white" aria-hidden="true" />*/}
                    <p className="ml-1">{label}</p>
                </div>
            </button>
        </div>
    )
}

export default SubmitButton